export const token_addresses = {
  customTokenAddress:"0xa70ebebD812E48E25D907A5bD9C78FfDA9DA9F59",
  composerAddress:"0xfb125E8463666389Af224B40d2cCE38BFE09bBd6",
  registryAddress:"0xB7aD37DA6A1138D68CcA3D69a62A0e4A260eBbEc"
}
